// extracted by mini-css-extract-plugin
module.exports = {"w1y7nvoh":"w1y7nvoh","r1xuh1hb":"r1xuh1hb","k67s48q":"k67s48q"};